import request from '@/utils/request'

export function getTemplateList(params) {
  return request({
    url: 'notice/template',
    method: 'get',
    params
  })
}

export function getSingleTemplate(data) {
  return request({
    url: 'notice/template/' + data,
    method: 'get'
  })
}

export function createTemplate(id, data) {
  return request({
    url: 'notice/template',
    method: 'post',
    data
  })
}

export function updateTemplate(id, data) {
  return request({
    url: 'notice/template/' + id,
    method: 'put',
    data
  })
}

export function deleteTemplate(data) {
  return request({
    url: 'notice/template/' + data,
    method: 'delete'
  })
}

export function renderTemplate(data) {
  return request({
    url: 'notice/template/render',
    method: 'post',
    data
  })
}
